var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emptyData",style:(("font-size:" + _vm.fontSize))},[_c('img',{attrs:{"src":require("@/assets/images/empty-CN.png"),"alt":"","srcset":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }